<template>
  <footer class="xm-tabbar">
    <slot></slot>
  </footer>
</template>

<script>
export default {
  name: "xm-tabbar"
};
</script>

<style lang="less">
@import "../core/variables.less";
@import "../core/mixins.less";

@tabbar-height: 0.98rem;

.xm-tabbar-content-page {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  bottom: @tabbar-height;
}

.xm-tabbar {
  background-color: white;
  position: absolute;
  bottom: 0;
  z-index: 100;
  .hairline(top, @color-split);
  .hairline-remove(bottom);
}

// tabbar bar margin
.xm-tabbar ~ .xm-tabbar-content-page {
  bottom: @tabbar-height;
}
// bar docked to bottom and used for primary app navigation
.xm-tabbar {
  bottom: 0;
  width: 100%;
  height: @tabbar-height;
  padding: 0;
  .hairline(top, @color-split);
  .hairline-remove(bottom);
  z-index: 9000; //less than popup
  transition-duration: 400ms;
  display: flex;

  // navigational tab (nested to be more specific for the icons in tab-items)
  .xm-tabbar-item {
    position: relative;
    height: @tabbar-height;
    color: @color-text-gray;
    text-align: center;
    flex: 1;
    width: 100%;
    padding-top: 0.1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    // active states for the tab bar
    &.active,
    &:active {
      color: @color-primary;
    }

    // activity badge on an icon
    .xm-badge {
      position: absolute;
      top: 10px;
      left: 50%;
      z-index: 100;
      height: 0.4rem;
      min-width: 0.4rem;
      padding: 0.01rem;
      font-size: 0.26rem;
      line-height: 0.26rem;
      color: white;
      vertical-align: top;
      background: red;
      border-radius: 0.08rem;
      margin-left: 0.2rem;
    }

    // tab icon
    .icon {
      top: 0.3rem;
      width: 0.44rem;
      height: 0.44rem;
      font-size: 0.44rem;
      line-height: 0.44rem;
      padding-top: 0;
      padding-bottom: 0;
      display: inline-block;
      vertical-align: middle;

      // make the text smaller if it's used with an icon '
      ~ label {
        display: block;
        font-size: 0.2rem;
        position: relative;
        top: 0.04rem;
      }
    }

    img {
      width: 0.48rem;
      ~ label {
        display: block;
        font-size: 0.2rem;
        position: relative;
        // top: 0.04rem;
      }
    }
  }
}

.xm-tabbar .icon {
  font-size: 0.4rem;
  line-height: 0.4rem;
}

// bars for search forms
// --------------------------------------------------

// // position/size search bar within the bar
// .xm-bar input[type="search"] {
//   height: 1.45rem;
//   margin: 0.3rem 0;
// }
</style>



// WEBPACK FOOTER //
// src/components/Tabbar.vue